import { IconLoader } from '@ui/src';
import { SheetTypes } from './types';
import Category from '../partial/reports/category';
import ReportHeader from '../partial/reports/header';
import formatReportBalance from '../../hoc/helpers/format-report-balance';

import ROUTES from '../../routes';

import cn from './capital-adequacy.module.css';

const CapitalAdequacy = ({
  items,
  itemsVisible,
  isLoading,
  search,
  ongoingCapitalRequirement,
  excessEligibleEquity,
  minimalCapitalRequirement,
  applicableOngoingCapitalRequirement,
  eligibleEquity,
  averageOutstandingEmoney,
}: SheetTypes) => {
  let content = (
    <div className={cn.reportLoader}>
      <IconLoader />
    </div>
  );

  if (!isLoading) {
    content = (
      <div className={cn.capitalAdequacyList}>
        {items?.map((item) => (
          <Category
            itemsVisible={itemsVisible}
            category={item}
            key={item.id}
            fromPath={ROUTES.REPORTS_CAPITAL_ADEQUACY}
            search={search}
            type="capital-adequacy"
          />
        ))}
      </div>
    );
  }

  return (
    <div className={cn.capitalAdequacyContent}>
      <ReportHeader />
      {content}
      <div className={cn.checksumsWrapper}>
        <div
          className={`${cn.checksum} ${cn.checksumWhite} ${cn.checksumBorder} ${cn.checksumSmall}`}
        >
          <div>Eligible equity</div>
          <div>
            {formatReportBalance(
              isLoading || !eligibleEquity ? 0 : eligibleEquity,
            )}
          </div>
        </div>
        <div
          className={`${cn.checksum} ${cn.checksumWhite} ${cn.checksumBorder} ${cn.checksumSmall}`}
        >
          <div>Average outstanding electronic money</div>
          <div>
            {formatReportBalance(
              isLoading || !averageOutstandingEmoney
                ? 0
                : averageOutstandingEmoney,
            )}
          </div>
        </div>
        <div
          className={`${cn.checksum} ${cn.checksumWhite} ${cn.checksumBorder} ${cn.checksumSmall}`}
        >
          <div>Ongoing capital requirement (Method D, 2% lAOEM)</div>
          <div>
            {formatReportBalance(
              isLoading || !ongoingCapitalRequirement
                ? 0
                : ongoingCapitalRequirement,
            )}
          </div>
        </div>
        <div
          className={`${cn.checksum} ${cn.checksumWhite} ${cn.checksumBorder} ${cn.checksumSmall}`}
        >
          <div>Minimum capital requirement (EUR350,000)</div>
          <div>
            {formatReportBalance(
              isLoading || !minimalCapitalRequirement
                ? 0
                : minimalCapitalRequirement,
            )}
          </div>
        </div>
        <div
          className={`${cn.checksum} ${cn.checksumWhite} ${cn.checksumBorder} ${cn.checksumSmall}`}
        >
          <div>Applicable ongoing capital requirements</div>
          <div>
            {formatReportBalance(
              isLoading || !applicableOngoingCapitalRequirement
                ? 0
                : applicableOngoingCapitalRequirement,
            )}
          </div>
        </div>
        <div
          className={`${cn.checksum} ${
            excessEligibleEquity && excessEligibleEquity < 0
              ? cn.checksumRed
              : ''
          }`}
        >
          <div>{`${
            excessEligibleEquity && excessEligibleEquity < 0
              ? 'Shortage'
              : 'Excess'
          } eligible equity`}</div>
          <div>
            {formatReportBalance(
              isLoading || !excessEligibleEquity ? 0 : excessEligibleEquity,
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CapitalAdequacy;
